import React from 'react'

const GroupMedical = () => {
    return (
        <div>
            <section className="page-header">
                <div className="page-header-bg-groupmedical"></div>
                <div className="container">
                    <div className="page-header__inner">
                        <div className="innerbanner">
                            <h4 className="text-custom-white no-margin">Group Medical</h4>
                        </div>
                        <h6 className='para_absdasa'>Best quotes for you !!!</h6>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default GroupMedical
